// @flow
import React from 'react'

type Props = {
  failed: Boolean,
  updatedAt: 'string'
}

export default class AnalysisStatus extends React.Component<Props> {
  render () {
    return (
      this.props.failed
        ? <span className='text-valencia'>
          <i className='icon-attention' />
                    analysis failed
        </span>
        : <span>Last updated:&nbsp;
          <strong>
            {this.props.updatedAt}
          </strong>
        </span>
    )
  }
}

window.Components.AnalysisStatus = React.createFactory(AnalysisStatus)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/Header/AnalysisStatus.js